<template>
	<div class="main suggested-departments">

		<div class="list-view">

			<div class="sub-header">
				<div class="input-with-control">
					<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="setFilter()" v-focus>
					<div class="button action input-go" @click="setFilter()"><i class="fas fa-search"></i></div>
				</div>
				<div class="controls">
					<pagination :paging="paging" @updatePage="goToPage"></pagination>
				</div>
			</div>

			<div v-if="showFilters" class="left-sidebar filters">
				<div class="note note-full-width">Add departments you want to display the best sellers from on your website.</div>
				<div class="button primary" @click="showDepartments()"><span>Add Best Seller Deparment</span></div>
				<div class="divider"></div>
  				<div class="note note-full-width">Drag items to rearrange the order and then click Save.</div>
				<div class="button primary" @click="saveSuggestedDepartments()"><span>Save Best Sellers</span></div>
                <message class="message" :message="message" @transitionDone="message = ''"></message>
			</div>

			<div class="detail" v-if="!loading">
				<div v-if="suggested_departments.length > 0" style="margin: 0 0 1em 0;">
					<b>TIP:</b> set no more than four best seller departments to keep your home page loading quickly.
				</div>
				<table v-if="suggested_departments.length > 0" style="width: 100%;">
					<draggable class="suggested_departments-items" handle=".drag" :sort="true" v-model="suggested_departments" group="suggested_departments" tag="tbody">
						<tr v-for="(department, index) in suggested_departments" class="draggable">
							<td :style="'width: 4em;' + (index == 3 ? 'padding-bottom: 1em; border-bottom: 1px solid #ccc;' : '')"><button class="delete" @click="deleteSuggestedDepartment(department.department_id)"><i class="fa fa-times"></i></button></td>
							<td :style="index == 3 ? 'padding-bottom: 1em; border-bottom: 1px solid #ccc;' : ''" class="drag">{{ department.description }}</td>
							<td :style="index == 3 ? 'padding-bottom: 1em; border-bottom: 1px solid #ccc;' : ''" class="drag">::</td>
						</tr>
					</draggable>
				</table>
				<div v-else class="empty-list">
					This list is empty
				</div>
			</div>
            <loading v-else></loading>
		</div>

		<div class="modal" v-if="showModal">
			<div class="inner">
				<h2>Add a best seller department</h2>
				<div class="content">
					<div v-if="departmentListMessage" class="message">{{ departmentListMessage }}</div>
					<ul v-if="departmentList.length > 0" class="clickable-list">
						<li v-for="department in departmentList" class="clickable-list-item" @click="assignDepartment(department)">
							{{ department.description }}
						</li>
					</ul>
				</div>
				<div class="controls">
					<div class="button cancel" @click="showModal = false">Cancel</div>
				</div>
			</div>
		</div>
		
		<help-popup :helpLink="{86:'Best Seller Departments', 106:'Website Template: Best Sellers'}" :tours="false"></help-popup>

	</div>
</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'suggested-departments',
	components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
			loading: false,
			showFilters: true,
			filters: {
				page: 1,
				search_term: '',
				published: false,
				unpublished: false
			},
			paging: {},
			message: '',
			clientId: '',
			suggested_departments: [],
			showModal: false,
			departmentList: [],
			departmentListMessage: ''
		}
	},
	created() {
		this.getList()
	},
	watch: {
	},
	computed: {
		hasFilters() {
			let filterIsSet = false
			for (var property in this.filters) {
				switch (property) {
					case 'hostname':
					case 'page':
					case 'source':
					case 'shopping_cart_id':
						break
					default:
						filterIsSet = this.filters[property] && this.filters[property] != ''
						break
				}
				if (filterIsSet) {
					return true
				}
			}
			return false
		}
	},
	methods: {
		getList() {
			this.loading = true
			this.apiCall({ destination: 'get_list_suggested_departments', data: this.filters } ).then(obj => {
				this.loading = false
				this.suggested_departments = obj.suggested_departments
			}).catch(err => {
				console.log(err)
			})
		},
		toggleFilter(which) {
			let currentValue = this.filters[which]
			this.filters.published = ''
			this.filters.unpublished = ''
			this.filters[which] = !currentValue
			this.filters.page = 1
			this.getList()
		},
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				published: false,
				unpublished: false
			}
			if (getList) {
				this.getList()
			}
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		showDepartments() {
			if (this.departmentList.length == 0) {
				this.departmentListMessage = 'Loading...'
				this.apiCall({ destination: 'get_list_departments' } ).then(obj => {
					this.departmentListMessage = ''
					this.departmentList = obj.departments
				}).catch(err => {
					console.log(err)
				})
			}
			this.showModal = true
		},
		assignDepartment(department) {
			let notInList = true
			for (let i = 0; i < this.suggested_departments.length; i++) {
				if (this.suggested_departments[i]['department_id'] == department.department_id) {
					notInList = false
					break;
				}
			}
			if (notInList) {
				this.suggested_departments.push(department)
				this.saveSuggestedDepartments()
			}
			this.showModal = false
		},
		deleteSuggestedDepartment(departmentId) {
			for (let i = 0; i < this.suggested_departments.length; i++) {
				if (this.suggested_departments[i]['department_id'] == departmentId) {
					this.suggested_departments.splice(i, 1)
					break;
				}
			}
			this.saveSuggestedDepartments()
		},
		saveSuggestedDepartments() {
			this.loading = true
			this.apiCall({ destination: 'save_list_suggested_departments', data: { suggested_departments: this.suggested_departments } } ).then(obj => {
				this.loading = false
                this.message = 'Saved'
			}).catch(err => {
				console.log(err)
			})
		}

	}
}
</script>

<style lang="scss" scoped>
.list-detail {
	display: grid;
	grid-template-columns: 1fr 0.5fr;
}
.message {
    text-align: center;
}
</style>
